import { useEffect } from "react";
import { useOpenAiGlobal } from "../use-openai-global";
import { createRoot } from "react-dom/client";
import { LoadingIndicator } from "@openai/apps-sdk-ui/components/Indicator";

interface ResumeOutput {
  resumePdf?: {
    download_url: string;
    file_id: string;
    res: any;
  };
  resumeTopping: string;
}

function App() {
  const toolOutput = useOpenAiGlobal("toolOutput") as ResumeOutput | null;
  const resumeStruct = toolOutput?.resumePdf?.res;
  // useEffect(() => {
  //   console.log("Resume Structure on update:", resumeStruct);
  // }, [resumeStruct]);

  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", padding: "20px" }}>
      { resumeStruct ? (
        <div className="flex items-center gap-2">
          <span>Resume Parsed Successfully!</span>
        </div>
      ) : (
        <div className="flex items-center gap-2">
          <LoadingIndicator
            size = {20}
            strokeWidth={2}
          />
          Resume Parsing...
        </div>
      )
      }
      {/* <pre>{JSON.stringify(resumeStruct, null, 2)}</pre> */}
    </div>
  );
}

const root = document.getElementById("parser-resume-root");

if (root) {
  createRoot(root).render(<App />);
}
